<template>
  <div class="text-ontick-carbon-900 dark:text-gray-300" id="plans">
    <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:px-8">
      <div class="sm:align-center sm:flex sm:flex-col">
        <h1 class="text-5xl font-extrabold sm:text-center">
          {{ header.title }}
        </h1>
        <p class="mt-5 text-xl text-gray-500 dark:text-gray-400 sm:text-center">
          {{ header.subtitle }}
        </p>
      </div>
      <div
        class="mt-12 space-y-4 sm:mt-16 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:mx-auto lg:max-w-4xl xl:max-w-none"
        :class="`md:grid-cols-${
          plans.length && plans.length < 4 ? plans.length : 4
        }`"
      >
        <div
          v-for="plan in plans"
          :key="plan.plan_name"
          class="border-ontick-steel-300 dark:bg-ontick-graphite-500 relative rounded-lg border-2 shadow-sm dark:border-none"
        >
          <!-- <div
            class="bg-ontick-red-600 absolute top-6 -right-8 flex rotate-45 transform items-center justify-center px-8 font-bold uppercase text-white"
          >
            <span> {{ plan.off_percent }}% off </span>
          </div> -->
          <div class="absolute top-0 right-0">
            <ontick-discount-badge-component
              v-if="plan.off_percent"
              :discount="plan.off_percent"
              :tooltip="plan.off_tooltip"
              :text="plan.off_text"
              :blackFriday="plan.is_black_friday"
            />
          </div>

          <div class="dark:divide-ontick-steel-500 divide-y divide-gray-200">
            <div class="p-6">
              <h2 class="text-lg font-medium leading-6">
                {{ plan.plan_name }}
              </h2>
              <p class="mt-4 text-sm text-gray-500 dark:text-gray-400">
                {{ plan.plan_desc }}
              </p>
              <div class="mt-8 flex flex-col" v-if="plan.plan_price">
                <div
                  v-if="plan.plan_original_price"
                  class="flex items-center justify-start space-x-2"
                >
                  <span class="font-semibold text-gray-500 dark:text-gray-400">
                    <s> R${{ formatCurrency(plan.plan_original_price) }} </s>
                  </span>
                  <p
                    class="card-price transform"
                    :class="{ 'black-friday': plan.is_black_friday }"
                    v-if="plan.off_tag"
                  >
                    {{ plan.off_tag }}
                  </p>
                </div>
                <div>
                  <span class="text-3xl font-extrabold">
                    R${{ formatCurrency(plan.plan_price) }}
                  </span>
                  {{ " " }}
                  <span
                    class="text-base font-medium text-gray-500 dark:text-gray-400"
                  >
                    /{{ billingFrequency(plan.billing_frequency) }}
                  </span>
                </div>
              </div>
              <p class="mt-8" v-else>
                <span class="text-3xl font-extrabold"> Grátis </span>
              </p>
              <ontick-button
                color="secondary"
                class="mt-8 w-full"
                @click.native="$emit('subscribe', plan)"
              >
                Assine {{ plan.plan_name }}
              </ontick-button>
            </div>
            <div class="px-6 pt-6 pb-8">
              <h3 class="text-xs font-medium uppercase tracking-wide">
                O que está incluso?
              </h3>
              <ul role="list" class="mt-6 space-y-4">
                <li
                  v-for="feature in plan.features.highlights"
                  :key="feature"
                  class="flex space-x-3"
                >
                  <i v-html="$icons.check" class="text-ontick-green-600"></i>
                  <span
                    class="text-sm font-bold text-gray-500 dark:text-gray-400"
                  >
                    {{ feature }}
                  </span>
                </li>
                <li
                  v-for="feature in plan.features.features"
                  :key="feature"
                  class="flex space-x-3"
                >
                  <i v-html="$icons.check" class="text-ontick-green-600"></i>
                  <span class="text-sm text-gray-500 dark:text-gray-400">
                    {{ feature }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OntickDiscountBadgeComponent from "../../../../shared/components/basic/ontick-discount-badge.component.vue";
export default {
  components: {
    OntickDiscountBadgeComponent,
  },

  props: {
    header: {
      type: Object,
    },
    plans: {
      type: Array,
    },
  },

  methods: {
    formatCurrency(val) {
      return val.toFixed(2).replaceAll(".", ",");
    },
    billingFrequency(billing_frequency) {
      switch (billing_frequency) {
        case "MONTH":
          return "mês";
        case "2_MONTH":
          return "bimestre";
        case "3_MONTH":
          return "trimestre";
        case "6_MONTH":
          return "semestre";
        case "YEAR":
          return "ano";
        default:
          return billing_frequency;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
s {
  text-decoration-color: gray;
  text-decoration-thickness: 2px;
}
.card-price {
  @apply bg-ontick-red-600 scale-75 transform;
  display: inline-block;

  width: auto;
  height: 38px;

  // background-color: #6ab070;
  -webkit-border-radius: 3px 4px 4px 3px;
  -moz-border-radius: 3px 4px 4px 3px;
  border-radius: 3px 4px 4px 3px;

  /* This makes room for the triangle */
  margin-left: 19px;

  position: relative;

  color: white;
  font-weight: 300;
  font-size: 16px;
  line-height: 38px;

  padding: 0 10px 0 10px;

  border-left: 1px solid #dd5b5b;

  &:before {
    content: "";
    position: absolute;
    display: block;
    left: -19px;
    width: 0;
    height: 0;
    border-top: 19px solid transparent;
    border-bottom: 19px solid transparent;
    border-right: 19px solid #dd5b5b;
  }

  &:after {
    content: "";
    background-color: white;
    border-radius: 50%;
    width: 4px;
    height: 4px;
    display: block;
    position: absolute;
    left: -9px;
    top: 17px;
  }

  &.black-friday {
    @apply bg-ontick-carbon-500;
    border-left: 1px solid #171e27;
    &:before {
      border-right: 19px solid #171e27;
    }
  }
}
</style>
